import { INGOMBRO_BASSO_VAR } from '@/components/layout/tabBarRoutes';

/**
 * IL REGISTRO dei contributi a `--ingombro-basso` (v3 fase 2, PR 9a): con la v3 piu' di una cosa puo' stare in basso insieme — la barra a quattro voci (`TabBarV3`), la barra del torneo
 * attivo (PR 9b/9c), il campo di scrittura di una conversazione (`useIngombroBasso`) — e la variabile e` UNA. Prima ciascuno la scriveva per conto suo e l'ultimo a scrivere vinceva; ora ognuno
 * REGISTRA la sua misura (una funzione: quanti px occupa dal fondo) e la variabile e` il MASSIMO delle misure registrate. Chi smonta toglie solo il suo contributo: la variabile resta quella degli
 * altri, e sparisce quando non ne resta nessuno.
 *
 * La misura e` di chi la registra (ognuno tiene il suo osservatore e chiama `aggiorna` quando la sua casella cambia): il registro non osserva niente, ricalcola il massimo rimisurando tutti.
 * Anche la `TabBar` di oggi (v3 spenta) passa di qui: registra la sua altezza, e da sola la variabile vale quanto la barra (come quando la scriveva da sola). Con la v3 spenta e un tavolo di carte (la
 * fascia in basso: mano e azioni) montato, la variabile e` il maggiore dei due.
 */
const contributi = new Map<symbol, () => number>();

function scrivi(): void {
  const root = document.documentElement;
  if (contributi.size === 0) {
    root.style.removeProperty(INGOMBRO_BASSO_VAR);
    return;
  }
  let massimo = 0;
  for (const misura of contributi.values()) massimo = Math.max(massimo, misura());
  root.style.setProperty(INGOMBRO_BASSO_VAR, `${massimo}px`);
}

export type ContributoIngombro = {
  /** Ricalcola e riscrive la variabile (la casella di chi ha registrato ha cambiato misura). */
  aggiorna: () => void;
  /** Toglie il contributo di chi ha registrato; la variabile resta quella degli altri. */
  rimuovi: () => void;
};

/** Registra la misura di una barra in basso (px dal fondo della finestra) e scrive subito la variabile. */
export function registraIngombroBasso(misura: () => number): ContributoIngombro {
  const id = Symbol('ingombro-basso');
  contributi.set(id, misura);
  scrivi();
  return {
    aggiorna: scrivi,
    rimuovi: () => {
      contributi.delete(id);
      scrivi();
    },
  };
}
